import list from './list';
import create from './create';
import edit from './edit';
import { isAdmin, isSuperAdmin } from '../../utils';

export default (permissions) => {
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);

  return {
    name: 'plot',
    list: isVisible ? list : null,
    edit: isVisible ? edit : null,
    create: isVisible ? create : null,
    icon: 'book-open',
    options: {
      menuIndex: 1,
      isHidden: !isVisible,
    },
  };
};
